import * as ReactDOMClient from 'react-dom/client';
import App from './App';
import log from 'loglevel';
import React from 'react';
import * as Sentry from '@sentry/react';

log.setLevel(import.meta.env.DEV ? log.levels.TRACE : log.levels.WARN);

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container as HTMLElement, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler(),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
